<template>
  <v-layout v-if="hasMeals" row wrap>
    <v-flex v-if="lunchItems.length > 0" xs12 md6 lg4>
      <h3>Almoço</h3>
      <h4 class="text-secondary mb-2">Lunch</h4>
      <div
        v-for="(item, index) in lunchItems"
        :key="`lunch-${index}`">
        {{ getDayTranslation(item.weekday) }}
      </div>
    </v-flex>

    <v-flex v-if="dinnerItems.length > 0">
      <h3>Janta</h3>
      <h4 class="text-secondary mb-2">Dinner</h4>
      <div
        v-for="(item, index) in dinnerItems"
        :key="`dinner-${index}`">
        {{ getDayTranslation(item.weekday) }}
      </div>
    </v-flex>
  </v-layout>

  <v-layout
    v-else
    align-center
    justify-center
    column>
    <h3>Não há registro sobre refeicões.</h3>
    <h4 class="text-secondary mb-2">There's no record of meals.</h4>
  </v-layout>
</template>

<script>
export default {
  name: 'FormStudentMeal',

  inject: ['resource'],

  data: () => ({
    dayTranslations: {
      monday: 'Segunda / Monday',
      tuesday: 'Terça / Tuesday',
      wednesday: 'Quarta / Wednesday',
      thursday: 'Quinta / Thursday',
      friday: 'Sexta / Friday'
    }
  }),

  computed: {
    lunchItems () {
      return this.resource.form.student_meals_attributes
        .filter(meal => meal.meal_alias === 'lunch')
        .sort((a, b) => a.day_number - b.day_number)
    },

    dinnerItems () {
      return this.resource.form.student_meals_attributes
        .filter(meal => meal.meal_alias === 'dinner')
        .sort((a, b) => a.day_number - b.day_number)
    },

    hasMeals () {
      return this.lunchItems.length > 0 && this.dinnerItems.length > 0
    }
  },

  methods: {
    getDayTranslation (weekday) {
      return this.dayTranslations[weekday]
    }
  }
}
</script>
